import React, { ReactNode } from 'react';
import { Box, BoxProps } from '@chakra-ui/core';

interface Props extends BoxProps {
  children?: ReactNode[] | ReactNode;
}

const Container: React.FC<Props> = ({ children, ...restProps }: Props) => {
  return (
    <Box height="100%" backgroundColor="gray.50" {...restProps}>
      {children}
    </Box>
  );
};

export default Container;
